import { render, staticRenderFns } from "./PhotoTab.vue?vue&type=template&id=d3dab48c&scoped=true&"
import script from "./PhotoTab.vue?vue&type=script&lang=js&"
export * from "./PhotoTab.vue?vue&type=script&lang=js&"
import style0 from "./PhotoTab.vue?vue&type=style&index=0&id=d3dab48c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3dab48c",
  null
  
)

export default component.exports